module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAMAAAAi2JHqAAAAQlBMVEUAAAD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgD/XgAUbXqnAAAAFXRSTlMAhWyZj/WecGCL7GZjldyjgnZcPgmPiiXRAAAAdUlEQVQoz53T2xKAEBSFYSmEdPb+r1ozubKwTC7/b6amti1u7VYp8GzxPQN2FcvgYhnmWIEjgc3BMJi6Qf6GkINPMHbDQqH2r3Q3nAn2HK5vTop1fA5/L2b8Lp59OwcyF5wjz6adLct4b/k9d5hxj/je1fb0AYAdFy6qKNrzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/next.png
// module id = 903
// module chunks = 5